import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import { SparkMenu } from '../../ui/spark';
import LeftMainmenuItem from '../../helpers/LeftMainmenuItem';
import { checkPermissions } from '../../../../lib/utils';
import { ACCESS_POINTS_GROUP } from '../../../constants/AccessPoints';

class NavigationManage extends Component {
    componentDidMount() {
        this.menuInstance = new SparkMenu(this.node);
    }

    render() {
        const { permissionSettings, location } = this.props;
        // TODO Extract MenuItems into separate field
        let menuItems;
        let returnPath;
        let returnPathDisplayText;
        if (/edit-theme$/.test(location.pathname)) {
            menuItems = [{ name: 'Edit Theme File', link: 'manage-theme/edit-theme' }];
            returnPath = '/manage/manage-theme';
            returnPathDisplayText = 'Back';
        } else if (/edit-configuration$/.test(location.pathname)) {
            menuItems = [{ name: 'Edit Configuration File', link: 'manage-configuration/edit-configuration' }];
            returnPath = '/manage/manage-configuration';
            returnPathDisplayText = 'Back';
        } else {
            returnPath = '/';
            returnPathDisplayText = 'Home';
            menuItems = [
                { name: 'Manage Themes', link: 'manage-theme' },
                { name: 'Manage Configuration', link: 'manage-configuration' },
                { name: 'Allow domains', link: 'domains' }
            ];
            if (permissionSettings.view) {
                menuItems.push({ name: 'Manage Apps', link: 'apps' });
            }
        }
        return (
            <div>
                <div className="container">
                    <Link to={returnPath}>
                        <div className="row">
                            <div className="col-md-2">
                                <i style={{ marginTop: 6 }} className="spark-icon-arrow-basic-left spark-icon--xd" />
                            </div>
                            <div className="col-md-10 link-to-home">{returnPathDisplayText}</div>
                        </div>
                    </Link>
                </div>
                <LeftMainmenuItem icon="spark-icon-tools" title="Manage" copy="" disabled />
                <div className="spark-panel__content leftnav-menu-submenu-container">
                    <nav
                        ref={node => (this.node = node)}
                        className="spark-menu spark-menu--panel col-xs-12 col-col-md-12 col-lg-12 col-xl-12"
                    >
                        <ul className="spark-menu__list">
                            {menuItems.map((elm, i) => {
                                return (
                                    <li key={`item${i}`} className="spark-menu__list-item">
                                        <span>
                                            <Link
                                                to={`/manage/${elm.link}`}
                                                activeClassName="active menu-link"
                                                className="spark-menu__list-link"
                                            >
                                                {elm.name}
                                            </Link>
                                        </span>
                                    </li>
                                );
                            })}
                        </ul>
                    </nav>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        permissionSettings: checkPermissions(state, ACCESS_POINTS_GROUP.THIRD_PARTY)
    };
};

NavigationManage.propTypes = {
    permissionSettings: PropTypes.shape({
        add: PropTypes.bool.isRequired,
        edit: PropTypes.bool.isRequired,
        delete: PropTypes.bool.isRequired,
        view: PropTypes.bool.isRequired
    }).isRequired,
    location: PropTypes.shape({}).isRequired
};

export default connect(mapStateToProps)(NavigationManage);



// WEBPACK FOOTER //
// ./src/components/pages/manage/NavigationManage.js